module.exports = __webpack_public_path__ + "media/images/doughnuts_cover-ea0b4e2b1d4fd027e33dfe0ef09c17b1.jpg";